// Author THQ
// Date 2025-04-06 01:01:55

class PpeInventory {
constructor({
        id = null,
        itemType = '',
        itemName = '',
        itemModel = '',
        description = '',
        quantity = '',
        itemUnit = '',
        binLocation = '',
        usageStatus = '',
        warehouseKeeper = '',
        warehouseNumber = '',
        safeQuantity = '',
        productionDate = '',
        warehousingDate = '',
        validityDate = '',
        attachment = '',
        remark = '',
        attachmentList = ''}
= {}) {
    this.id = id;
    this.itemType = itemType;
    this.itemName = itemName;
    this.itemModel = itemModel;
    this.description = description;
    this.quantity = quantity;
    this.itemUnit = itemUnit;
    this.binLocation = binLocation;
    this.usageStatus = usageStatus;
    this.warehouseKeeper = warehouseKeeper;
    this.warehouseNumber = warehouseNumber;
    this.safeQuantity = safeQuantity;
    this.productionDate = productionDate;
    this.warehousingDate = warehousingDate;
    this.validityDate = validityDate;
    this.attachment = attachment;
    this.remark = remark;
    this.attachmentList = attachmentList;
}
}

function newEntity() {
return new PpeInventory();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.ppe.ppeInventory.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'itemType',
        label: 'label.em.ppe.ppeInventory.grid.itemType',
        sortable: true,
        form: {
        type: 'dictEnumSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'ppe_material_type'
                        }
        },
        {
        key: 'itemName',
        label: 'label.em.ppe.ppeInventory.grid.itemName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'itemModel',
        label: 'label.em.ppe.ppeInventory.grid.itemModel',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'description',
        label: 'label.em.ppe.ppeInventory.grid.description',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'quantity',
        label: 'label.em.ppe.ppeInventory.grid.quantity',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'itemUnit',
        label: 'label.em.ppe.ppeInventory.grid.itemUnit',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'binLocation',
        label: 'label.em.ppe.ppeInventory.grid.binLocation',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'usageStatus',
        label: 'label.em.ppe.ppeInventory.grid.usageStatus',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '0', text: '停用' },
                            { value: '1', text: '正常' }
            ]
                }
        },
        {
        key: 'warehouseKeeper',
        label: 'label.em.ppe.ppeInventory.grid.warehouseKeeper',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'warehouseNumber',
        label: 'label.em.ppe.ppeInventory.grid.warehouseNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'safeQuantity',
        label: 'label.em.ppe.ppeInventory.grid.safeQuantity',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'productionDate',
        label: 'label.em.ppe.ppeInventory.grid.productionDate',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'warehousingDate',
        label: 'label.em.ppe.ppeInventory.grid.warehousingDate',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'validityDate',
        label: 'label.em.ppe.ppeInventory.grid.validityDate',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'attachmentList',
        label: 'label.em.ppe.ppeInventory.grid.attachmentList',
        sortable: true,
            isDetail: true,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.em.ppe.ppeInventory.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    itemTypeFilter : '',
    itemNameFilter : '',
    itemModelFilter : '',
    descriptionFilter : '',
    quantityLeFilter : '',
    quantityGeFilter : '',
    itemUnitFilter : '',
    binLocationFilter : '',
    usageStatusFilter : '',
    warehouseKeeperFilter : '',
    warehouseNumberFilter : '',
    productionDateRteFilter : '',
    productionDateLteFilter : '',
    warehousingDateRteFilter : '',
    warehousingDateLteFilter : '',
    validityDateRteFilter : '',
    validityDateLteFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'itemTypeFilter',
        label: 'label.em.ppe.ppeInventory.filter.itemType',
        disabled: false,
        form: {
        type: 'dictEnumSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'ppe_material_type'
                }
        },
        {
        key: 'itemNameFilter',
        label: 'label.em.ppe.ppeInventory.filter.itemName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'itemModelFilter',
        label: 'label.em.ppe.ppeInventory.filter.itemModel',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'descriptionFilter',
        label: 'label.em.ppe.ppeInventory.filter.description',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'quantityLeFilter',
        label: 'label.em.ppe.ppeInventory.filter.quantityLe',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'quantityGeFilter',
        label: 'label.em.ppe.ppeInventory.filter.quantityGe',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'itemUnitFilter',
        label: 'label.em.ppe.ppeInventory.filter.itemUnit',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'binLocationFilter',
        label: 'label.em.ppe.ppeInventory.filter.binLocation',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'usageStatusFilter',
        label: 'label.em.ppe.ppeInventory.filter.usageStatus',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '0', text: '停用' },
                { value: '1', text: '正常' }
            ]
        }
        },
        {
        key: 'warehouseKeeperFilter',
        label: 'label.em.ppe.ppeInventory.filter.warehouseKeeper',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'productionDateRteFilter',
        label: 'label.em.ppe.ppeInventory.filter.productionDateRte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'productionDateLteFilter',
        label: 'label.em.ppe.ppeInventory.filter.productionDateLte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'warehousingDateRteFilter',
        label: 'label.em.ppe.ppeInventory.filter.warehousingDateRte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'warehousingDateLteFilter',
        label: 'label.em.ppe.ppeInventory.filter.warehousingDateLte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'validityDateRteFilter',
        label: 'label.em.ppe.ppeInventory.filter.validityDateRte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'validityDateLteFilter',
        label: 'label.em.ppe.ppeInventory.filter.validityDateLte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'itemType',
        label: 'label.em.ppe.ppeInventory.entity.itemType',
        sortable: true,
        disabled: false,
        form: {
        type: 'dictEnumSelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'ppe_material_type'
                }
        },
        {
        key: 'itemName',
        label: 'label.em.ppe.ppeInventory.entity.itemName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
            ,required: true
                }
        },
        {
        key: 'itemModel',
        label: 'label.em.ppe.ppeInventory.entity.itemModel',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'description',
        label: 'label.em.ppe.ppeInventory.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'quantity',
        label: 'label.em.ppe.ppeInventory.entity.quantity',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
            ,required: true
                }
        },
        {
        key: 'itemUnit',
        label: 'label.em.ppe.ppeInventory.entity.itemUnit',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'binLocation',
        label: 'label.em.ppe.ppeInventory.entity.binLocation',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'usageStatus',
        label: 'label.em.ppe.ppeInventory.entity.usageStatus',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: '0', text: '停用' },
                { value: '1', text: '正常' }
            ]
        }
        },
        {
        key: 'warehouseKeeper',
        label: 'label.em.ppe.ppeInventory.entity.warehouseKeeper',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
            ,fieldsBindingByEntityModalSelected: '{"warehouseNumber":"employeeId"}'
                }
        },
        {
        key: 'safeQuantity',
        label: 'label.em.ppe.ppeInventory.entity.safeQuantity',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'productionDate',
        label: 'label.em.ppe.ppeInventory.entity.productionDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'warehousingDate',
        label: 'label.em.ppe.ppeInventory.entity.warehousingDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'validityDate',
        label: 'label.em.ppe.ppeInventory.entity.validityDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.em.ppe.ppeInventory.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'attachmentList',
        label: 'label.em.ppe.ppeInventory.entity.attachment',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
            ,correspondingField: 'attachment'
                }
        }
]

export {PpeInventory, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
